import { Input } from "../ui/input";
import { Textarea } from "../ui/textarea";
import { Label } from "../ui/label";

export const Field = ({ label, hint, value, onChange, textarea, testid, type = "text", rows = 3, ...rest }) => (
  <div className="space-y-2">
    <Label className="text-sm text-zinc-300">{label}</Label>
    {textarea ? (
      <Textarea data-testid={testid} value={value ?? ""} onChange={(e) => onChange(e.target.value)} rows={rows} className="text-base bg-[#0B0B0B] border-zinc-800 focus-visible:ring-[#D4AF37]/60" {...rest} />
    ) : (
      <Input data-testid={testid} type={type} value={value ?? ""} onChange={(e) => onChange(e.target.value)} className="admin-input" {...rest} />
    )}
    {hint && <p className="text-xs text-zinc-500 leading-relaxed">{hint}</p>}
  </div>
);

export const Panel = ({ title, desc, children, testid }) => (
  <section data-testid={testid} className="bg-[#0A0A0A] border border-zinc-800/80 rounded-lg p-5 sm:p-7 space-y-5">
    {title && (
      <div>
        <h2 className="font-display text-2xl text-zinc-50">{title}</h2>
        {desc && <p className="text-sm text-zinc-500 mt-1">{desc}</p>}
      </div>
    )}
    {children}
  </section>
);

export const PageTitle = ({ title, desc, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8">
    <div>
      <h1 className="font-display text-4xl text-zinc-50">{title}</h1>
      {desc && <p className="text-sm text-zinc-500 mt-2 max-w-xl">{desc}</p>}
    </div>
    {children}
  </div>
);
